import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  /** `Invoice` data object. */
  item: Invoice;
}


import { computed } from 'vue';

import type { Invoice } from '@models';

import { faCircle } from '@icons/regular/faCircle';
import { faCheck } from '@icons/regular/faCheck';
import { faFilePen } from '@icons/regular/faFilePen';
import { faExclamationTriangle } from '@icons/regular/faExclamationTriangle';
import { faBan } from '@icons/regular/faBan';

declare module 'vue/types/vue' {
  export interface Vue {
    TableCellInvoiceStatus: ComponentWithProps<Props>;
  }
}

const STATUS_MAP = {
  draft: {
    text: 'Draft',
    color: 'secondary',
    icon: faFilePen,
  },
  open: {
    text: 'Open',
    color: 'primary',
    icon: faCircle,
  },
  paid: {
    text: 'Paid',
    color: 'success',
    icon: faCheck,
  },
  uncollectible: {
    text: 'Uncollectible',
    color: 'danger',
    icon: faExclamationTriangle,
  },
  void: {
    text: 'Void',
    color: 'primary',
    icon: faBan,
  },
} as const satisfies Record<Invoice.Status, object>;

const __default__ = { name: 'TableCellInvoiceStatus' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  /** `Invoice` data object. */
  item: Invoice;
};

/**
 * `TableCellInvoiceStatus` component properties.
 */


const status = computed(() => {
  try {
    return STATUS_MAP[props.item.status];
  } catch {
    return null;
  }
});

return { __sfc: true,STATUS_MAP, props, status }
}

})